import { ESPACES } from "../../../hooks/useEspaceActif/useEspaceActif";
import { estClientQuittancePersonnel } from "../../../helpers/ficheClient";

export const filtrerFacturesParEspace = (factures, espace) => {
  if (espace !== ESPACES.PARTICULIER && espace !== ESPACES.ENTREPRISE) {
    return factures;
  }
  const vouluPersonnel = espace === ESPACES.PARTICULIER;
  return factures.filter(
    (facture) => estClientQuittancePersonnel(facture) === vouluPersonnel
  );
};
